export const isEmptyArray = (array) => array.length === 0;
